import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';

import './FormActions.styles.scss';

type FormActionsProps = {
  className?: string;
  submitDisabled?: boolean;
  onCancel: () => void;
};

const FormActions: React.FC<FormActionsProps> = (props) => {
  const { className, submitDisabled = false, onCancel } = props;

  const classes = classNames('form-actions', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <Button variant="link" onClick={onCancel}>
        {t('cancel')}
      </Button>
      <Button disabled={submitDisabled} type="submit">
        {t('save')}
      </Button>
    </div>
  );
};

export default FormActions;
